export default __webpack_public_path__ + "static/oilchange1-7e9bd7e9197153dfeaafe1b3d28482e5.jpg";